import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Intent } from "@blueprintjs/core";
import SendEmailPanel from "components/Common/SendEmailPanel";
import Toast from 'helpers/toaster';

// Email a work order to the client, in a side panel (components/Common/SendEmailPanel).
@inject("workReportStore")
@observer
class SendWorkReportModal extends Component {

  componentDidMount() {
    let { object } = this.props.workReportStore.SendWorkReport;
    object.emailSubject = "Work Order [#"+this.props.workReportStore.workReport.object.attributes.number+"] from "+this.props.workReportStore.workReport.object.attributes.tenant.name
  }

  handleCloseQuoteInvoiceDialog() {
    this.props.onClose();
  }

  SendWorkReportToEmail() {
    this.props.workReportStore.SendWorkReportToEmail()
      .then(() => {
        this.props.onClose();
        Toast.show({ message: "Work order sent.", intent: Intent.SUCCESS });
      })
      .catch(() => {
        Toast.show({ message: "Couldn’t send the work order. Try again.", intent: Intent.DANGER });
      });
  }

  onEmailChange = (emails) => {
    this.props.workReportStore.SendWorkReport.object.emailTo = emails.map((contact) => contact.email);
  }

  render() {
    const { SendWorkReport, workReport } = this.props.workReportStore;
    const client = workReport.object.attributes && workReport.object.attributes.client;
    return (
      <SendEmailPanel
        isOpen={this.props.isOpen}
        onClose={this.handleCloseQuoteInvoiceDialog.bind(this)}
        what="work order"
        tone="field"
        object={SendWorkReport.object}
        contacts={client ? [{ email: client.email, name: client.name }] : []}
        busy={Boolean(SendWorkReport.isLoading)}
        onEmailChange={this.onEmailChange}
        onSend={this.SendWorkReportToEmail.bind(this)}
      />
    )
  }

}

export default SendWorkReportModal;
